// @core/api/endpoints/subscription/subscribe_to_bundle.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BundleSubscriptionResponse,
  SubscribeToBundleRequest,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Subscribe tenant to product bundle
 * Subscribes a tenant to a product bundle. Creates subscriptions for all included products with bundle discount applied.
 */
export async function SubscribeToBundle(
  bundle_id: string,
  data: SubscribeToBundleRequest,
  options?: RequestOptions
): Promise<BundleSubscriptionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/bundles/:bundle_id/subscribe`;
  requestPath = requestPath.replace(':bundle_id', encodeURIComponent(bundle_id));
  const requestOptions = options;
  return client.post<BundleSubscriptionResponse>(requestPath, data, requestOptions);
}
